













































import { Component, Vue } from "vue-property-decorator";
import tipModel from "../model/tipModel.vue";
import exportExcel from "../../model/exportExcel.vue";
import { settlementList } from "@/req/settlement";
@Component({
  components: { tipModel, exportExcel },
})
export default class Home extends Vue {
  public loading = false;
  public page = 1;
  public size = 10;
  public data: any = [];
  public columns: any = [
    {
      title: "订单号",
      key: "order_num",
      align: "center",
    },
    {
      title: "游戏名",
      key: "game_name",
      align: "center",
    },
    {
      title: "所属GM",
      key: "account",
      align: "center",
    },
    {
      title: "申请周期",
      key: "cycle_time",
      align: "center",
    },
    {
      title: "结算周期交易行金额",
      key: "total_amount",
      align: "center",
    },
    {
      title: "申请金额",
      key: "apply_gm_amount",
      align: "center",
    },
    {
      title: "通道费",
      key: "passage_fee",
      align: "center",
    },
    {
      title: "实际到账金额",
      key: "gm_amount",
      align: "center",
    },
    {
      title: "结算状态",
      key: "status",
      align: "center",
    },
    {
      title: "结算渠道",
      key: "type",
      align: "center",
    },
    {
      title: "申请时间",
      key: "apply_time",
      align: "center",
    },
    // {
    //   title: "申请人员",
    //   key: "apply_acount",
    //   align: "center",
    // },
    {
      title: "操作",
      slot: "action",
      align: "center",
    },
  ];
  public baseList: any = {
    orderId: "",
    gameId: "",
    gmName: "",
    settleChannel: "",
  };
  public parentList(data) {
    this.baseList = data;
    this.page = 1;
    this.getList();
  }
  public mounted() {
    this.getList();
  }
  public change(index) {
    this.page = index;
    this.getList();
  }
  public sizeChange(size) {
    this.page = 1;
    this.size = size;
    this.getList();
  }
  public getReturnList(state) {
    if (state == 1) {
      if (this.page != 1) {
        this.page = this.page - 1;
      }
    } else {
      if (this.data.data.length == 1 && this.page != 1) {
        this.page = this.page - 1;
      }
      if (this.data.data.length == 0 && this.page != 1) {
        this.page = this.page - 1;
      }
    }
    setTimeout(() => {
      this.getList();
    }, 500);
  }
  public async getList() {
    this.loading = true;
    const res = await settlementList({
      token: this.$fn.cookies.getToken("token"),
      game_name: this.baseList.gameId || "",
      order_num: this.baseList.orderId || "",
      account: this.baseList.gmName || "",
      type: this.baseList.settleChannel || "",
      page: this.page,
      pagenum: this.size,
    });
    if (res.code == 0) {
      this.data = res.data;
      this.loading = false;
    }
  }
  public save(state, row) {
    const $tipModel: any = this.$refs.tipModel;
    if (state == 1) {
      const arr: any = [];
      this.data.data.forEach((item) => {
        arr.push(item.id);
      });
      $tipModel.show(state, arr.toString());
    } else {
      $tipModel.show(state, row.id);
    }
  }
  public exportExcel() {
    const $exportExcel: any = this.$refs.exportExcel;
    $exportExcel.show(2);
  }
}
